import { render } from "./FormSelect.vue?vue&type=template&id=90854aee&scoped=true"
import script from "./FormSelect.vue?vue&type=script&lang=js"
export * from "./FormSelect.vue?vue&type=script&lang=js"

import "./FormSelect.vue?vue&type=style&index=0&id=90854aee&lang=scss&scoped=true"

import exportComponent from "/Users/lei.cao/Documents/PRIME_PreProc/ImageQC/SwipesForScience/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90854aee"]])

export default __exports__